var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.ColumnContent,
    {
      attrs: {
        title: _setup.transDynamic(
          _setup.context.lpu_type,
          `name,${_setup.language},${_setup.needTranslate}`
        ),
      },
    },
    _vm._l(_setup.context.towns, function (town) {
      return _c(
        "a",
        {
          key: town.translit,
          staticClass:
            "d-table text--text link-decoration-none mb-4 text-body-1",
          attrs: {
            "data-qa": "lpu-types-link",
            href: _setup.reverseFullL10N({
              name: "lpulist",
              args: {
                town_translit: town.translit,
                lpu_type_translit: _setup.context.lpu_type.translit,
                language: _setup.urlLang,
              },
            }),
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _setup.transDynamic(
                  town,
                  `name,${_setup.language},${_setup.needTranslate}`
                )
              ) +
              "\n  "
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }